<template>
  <div>
    <!-- 侧边栏-展开 -->
    <transition name="slide">
      <div v-if="isSidebarVisible" class="sidebar">
        <div class="close_info">
          <div class="userInfo">
            <el-avatar v-if="userInfo.head_img" :size="40" :src="userInfo.head_img" />
            <template v-else>
              <el-avatar v-if="userInfo.is_sex == 1" :size="40" :src="require('@/assets/img/user_info/man.png')" />
              <el-avatar v-if="userInfo.is_sex == 0" :size="40" :src="require('@/assets/img/user_info/girl.png')" />
            </template>
            <span v-if="userInfo" style="margin-left: 10px;">{{ userInfo.user_name }}</span>
            <span v-if="!userInfo.like_city || !userInfo.like_sp || !userInfo.score"
              style="font-size: 12px; margin-left: 10px; color: red; padding: 2px 4px; border-radius: 3px;"
              @click="toUserInfo()">
              请完善资料</span>
          </div>
        </div>
        <div class="create" @click="newChat()">
          <i class="iconfont luming-pc-create" style="color: #0057ff; font-size: 22px;  "></i>
          帮问智答
        </div>
        <div class="section-item-title">
          <i class="iconfont luming-pc-news" style="color: #3D3D3D; font-size: 22px;"></i>
          历史记录
        </div>
        <div class="ds-scroll-area">
          <div v-for="(item, i) in chatList" :key="i" @click="getHistory(item)" class="old-list">
            <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
              <span>{{ item.title }}</span>
            </el-tooltip>
          </div>
        </div>

        <!-- 侧边栏底部 -->
        <div class="back-home">
          <div @click="backHome()">
            <span>
              <i class="iconfont luming-pc-back-home" style="color: #3D3D3D; font-size: 22px;  "></i>
              返回网站主页
            </span>
          </div>
          <div>
            <el-tooltip class="item" effect="dark" content="收起侧栏" placement="right">
              <i class="iconfont luming-pc-zhankai" @click="isSidebarVisible = !isSidebarVisible"
                style="color: #0057ff; font-size: 22px;  "></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </transition>

    <!-- 侧边栏-收起 -->
    <transition name="slide">
      <div v-if="!isSidebarVisible" class="sidebars">
        <el-tooltip class="item" effect="dark" content="展开侧栏" placement="right">
          <i class="iconfont luming-pc-zhankai" @click="isSidebarVisible = !isSidebarVisible"
            style="color: #0057ff; font-size: 22px;  "></i>
        </el-tooltip>
        <!-- 侧边栏内容 -->
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: '',
  props: ['chatList'],
  data() {
    return {
      //侧边栏状态
      isSidebarVisible: true,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
  },
  methods: {
    getHistory(e) {
      this.$emit('getHistory', e)
    },
    newChat() {
      this.$emit('newChat')
    },
    backHome() {
      this.$router.push("/");
    },
    toUserInfo() {
      this.$router.push("/user/info")
    }
  },
};
</script>

<style scoped lang='less'>
/* 动画效果 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
  /* 平滑过渡效果 */
}

.slide-enter,
.slide-leave-to

/* .slide-leave-active 在 <2.1.8 版本中使用 */
  {
  transform: translateX(-100%);
  /* 完全隐藏侧边栏 */
}


.sidebar {
  display: inline-block;
  width: 280px;
  height: 100vh;
  background: #F3F4F6;
  border-right: .5px solid var(--s-color-border-tertiary, rgba(0, 0, 0, .08));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 18px;
}

.sidebars {
  position: fixed;
  bottom: 10px;
  left: 15px;
  padding: 20px;
}

.close_info {
  padding: 30px 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .userInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.create {
  color: #2355F6;
  background: #E6EAF6;
  border-radius: 15px;
  cursor: pointer;
  padding: 8px 16px;

  display: flex;
  align-items: center;
  /* 垂直居中对齐 */

  font-size: 18px;
  /* 图标与文本之间的间距 */
  gap: 10px;
}

.section-item-title {
  display: flex;
  align-items: center;
  padding: 20px;
  font-size: 18px;
  gap: 10px;
  // color: #0000004D;
}

.ds-scroll-area {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #ebebfc transparent;
  padding-top: 10px;

  .old-list {
    color: #3D3D3D;
    padding: 10px 30px;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏溢出的文本 */
    text-overflow: ellipsis;
  }

  .old-list:hover {
    background: #D8D8D8;
    cursor: pointer;
  }
}

.back-home {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-top: 2px solid #D8D8D8;
  color: #3D3D3D;
}
</style>
